import { useRefinementList } from "react-instantsearch-core";

export const useFacetController = () => {
  const city = useRefinementList({
    attribute: "property.city",
    limit: 999
  });
  const property = useRefinementList({
    attribute: "property.name",
    limit: 999
  });

  const rentersStatus = useRefinementList({
    attribute: "status",
    limit: 999
  });

  return {
    "property.city": city,
    "property.name": property,
    status: rentersStatus
  };
};
